<template>
    <div class="reject-refund-dialog">

        <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-form-item label="Lý do kế toán từ chối">
                <el-input :value="accountingRejectReason || ''" disabled/>
            </el-form-item>
            <el-form-item label="Ghi chú" prop="note">
                <el-input
                    v-model="form.note"
                    :rows="4"
                    maxlength="500"
                    placeholder="Nhập ghi chú xử lý"
                    show-word-limit
                    type="textarea"
                />
            </el-form-item>
        </el-form>

        <div class="reject-refund-dialog__footer">
            <button :disabled="submitting" class="btn btn-secondary-muted" type="button" @click="closeDialog">
                Hủy bỏ
            </button>
            <el-button
                :disabled="submitting"
                :loading="submitting"
                class="btn btn-primary text-white reject-refund-dialog__btn-submit"
                type="button"
                @click="submit"
            >
                Xác nhận
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "DialogRejectDepositRefund",
    props: {
        accountingRejectReason: {
            type: String,
            default: "",
        },
        submitting: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: {
                note: "",
            },
            rules: {
                note: [{required: true, message: "Vui lòng nhập ghi chú xử lý", trigger: "blur"}],
            },
        };
    },
    mounted() {
        this.resetForm();
    },
    methods: {
        resetForm() {
            this.form = {note: ""};
            this.$nextTick(() => {
                this.$refs.form?.clearValidate();
            });
        },
        closeDialog() {
            this.resetForm();
            this.$emit("closeDialog");
        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                this.$emit("submit", {note: (this.form.note || "").trim()});
            });
        },
    },
};
</script>

<style scoped>
.reject-refund-dialog {
    padding: 4px 4px 0;
}

.reject-refund-dialog__title {
    font-size: 16px;
    font-weight: 500;
    color: #181c32;
    margin-bottom: 14px;
    line-height: 1.4;
}

.w-100 {
    width: 100%;
}

.reject-refund-dialog :deep(.el-form-item) {
    margin-bottom: 14px;
}

.reject-refund-dialog :deep(.el-form-item__label) {
    padding-bottom: 6px;
    line-height: 1.35;
    color: #3f4254;
    font-weight: 500;
}

.reject-refund-dialog :deep(.el-input__inner),
.reject-refund-dialog :deep(.el-textarea__inner) {
    border-radius: 6px;
}

.reject-refund-dialog :deep(.el-input__inner) {
    height: 40px;
    line-height: 40px;
}

.reject-refund-dialog :deep(.el-textarea__inner) {
    min-height: 90px !important;
    padding-top: 10px;
}

.reject-refund-dialog :deep(.el-form-item:last-child) {
    margin-bottom: 0;
}

.reject-refund-dialog__footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 18px;
    padding-top: 14px;
    border-top: 1px solid #ebedf3;
}

.btn-secondary-muted {
    background: #cacaca;
    border: none;
    color: #333;
}

.reject-refund-dialog__footer .btn {
    min-width: 86px;
    height: 38px;
    border-radius: 4px;
}

.reject-refund-dialog__btn-submit {
    margin: 0;
}
</style>
